@if(!jobID) {
<h1 class="text-[24px] text-primary m-[2%]">Search Results</h1>
} @else {
<div class="m-[2%] flex justify-between">
  <span class="text-[24px] text-primary flex" routerLink="/activity-queue">
    <svg
      width="38"
      height="38"
      viewBox="0 0 38 38"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect x="1" y="1" width="36" height="36" rx="5" stroke="#007C91" />
      <rect
        x="9"
        y="9"
        width="20"
        height="20"
        fill="black"
        fill-opacity="0.01"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M22.2496 10.75L14 18.9996L22.2496 27.2492L23.4281 26.0706L16.357 18.9996L23.4281 11.9285L22.2496 10.75Z"
        fill="#007C91"
      />
    </svg>
    <span class="ml-4"
      >Asset Import:
      <span class="text-sm"> ID:{{ jobID }}</span>
    </span>
  </span>
</div>
}
<div class="grid grid-cols-12 px-[4%]">
  <dal-shared-ui-search-filter
    [filters]="filters"
    [showFilters]="showFilters"
    (ToggleFilterSection)="showFilters = !showFilters"
    (CheckedFilters)="onCheckedFilters($event)"
    (KeywordSearch)="keywordChanged($event)"
    [ngClass]="{
      filters: true,
      'w-[40px] overflow-hidden': showFilters,
      'col-span-2': !showFilters
    }"
  ></dal-shared-ui-search-filter>
  <dal-shared-ui-search-preview
    class="border-custom"
    [ngClass]="showFilters ? '-ml-[5%] col-span-11' : 'col-span-10'"
    [searchTerm]="searchTerm"
    [termFilters]="termFilters"
    [dataSource]="dataSource"
    [loading]="loading"
    [searchCount]="searchCount"
    (PageChangeEvent)="pageChanged($event)"
    (SortChangeEvent)="sortChanged($event)"
  ></dal-shared-ui-search-preview>
</div>
